// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"1c9fbd4d","380":"33689b58","496":"3b8c1c3f","702":"f7992cd3"}[chunkId] + ".chunk.js";
};